import React, { useState } from 'react';
import classnames from 'classnames';

import Button from '../components/Button';
import { useReturnState } from '../ReturnsPageApp';
import { makeBtStyles } from '../Theme';
import axios from 'axios';


const useStyles = makeBtStyles( theme => ({
  form: {
    width: '500px'
  },
  heading: {
    ...theme.characteristicFont,
    fontSize: '21px',
    textAlign: 'center',
  },
  input: {
    width: '100%',
    marginBottom: '12px',
    borderRadius: '3px',
    fontSize: '14px',
    height: '40px',
    padding: '8px',
    border: '1px solid #DDDDDD',
    '&:focus': {
      outline: 'none',
      borderColor: theme.main.color,
    },
    '&.hasError': {
      borderColor: '#E73434',
    },
    '&::placeholder': {
      color: 'gray'
    },
    '&:-ms-input-placeholder': {
      color: 'gray'
    },
    '&::-ms-input-placeholder': {
      color: 'gray'
    }
  },
  button: {
    width: '100%',
    marginTop: '12px',
    fontSize: '16px'
  },
  error: {
    fontSize: '12px',
    color: '#E73434',
    maxWidth: '245px'
  }
}));


export default function FindOrderForm({ className='' }) {
  const classes = useStyles();
  const { setOrder } = useReturnState();
  const [form, setForm] = useState({ order_number: '', zip_code: '' });
  const [loading,setLoading] = useState(false);
  const [errors,setErrors] = useState<any>();

  const onFieldChange = (event:any) => {
    const { name, value } = event.target;
    setForm( oldForm => ({ ...oldForm, [name]: value }) );
  }

  const onSubmit = (event: any) => {
    event.preventDefault();

    if( !form.order_number ) {
      setErrors({ order_number: 'You must provide an order number.' });
    }
    else if( !form.zip_code ) {
      setErrors({ zip_code: 'You must provide a zip code.' });
    }
    else {
      setErrors(null);
      setLoading(true);
      axios.get('/find-order').then(
        (response) => {
          setLoading(false);
          setOrder(response.data);
        },
        (error) => setErrors(error)
      );
    }
  }

  const submitDisabled = !form.order_number || !form.zip_code || loading;

  return <form onSubmit={onSubmit} className={classnames(classes.form,className)}>
    <h2 className={classes.heading}>Start Your Return</h2>
    <div>
      <input
        id="return-order-number"
        type="text"
        placeholder="Order Number"
        value={form.order_number}
        name='order_number'
        onChange={onFieldChange}
        className={classnames(classes.input, { hasError: errors?.order_number })}
      />
    </div>
    <div>
      <input
        id="return-zip-code"
        type="text"
        placeholder="Zip Code"
        value={form.zip_code}
        name='zip_code'
        onChange={onFieldChange}
        className={classnames(classes.input, { hasError: errors?.zip_code })}
      />
    </div>
    { !!errors &&  
      <div className={classes.error}>
        { Object.values(errors).join(" ") }
      </div>
    }
    <Button type="submit" variant="primary" className={classes.button} disabled={submitDisabled}>
      { loading ? 'Looking Up Order' : 'Look Up Order' }
    </Button>
  </form>;
}